__turbopack_context__.v({
  "location-details": "LocationDetails-module-scss-module__zewjjq__location-details",
});
